import {
  Card,
  CardContent,
  Grid,
  Switch,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSAutocompleteField from "../../Components/AutoComplete/AutoComplete";
import WSSelectField from "../../Components/Select/WSSelect";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { Price } from "./Price";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import WSButton from "../../Components/Button/WSButton";

export const Item: React.FC<any> = React.memo((props) => {
  const [isProduct, setIsProduct] = useState(false);
  const { control, register, handleSubmit, setValue, reset } = useForm<any>();
  const { tab } = useParams();
  const tabNum = Number(tab) || 0;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false);

  const tabsData: any[] = [
    { label: "Pricing", content: <Price /> },
    { label: "Stock", content: "" },
  ];

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsProduct(event.target.checked);
  };

  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };

  const handleDataSaveAndNew = () => {};

  const handleClose = () => {
    navigate("/");
  };

  return (
    <form>
      <Card>
        <CardContent>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            wrap="nowrap"
          >
            <Grid item>
              <Grid container spacing={2} alignItems="center" wrap="nowrap">
                <Grid item>
                  <Typography fontWeight="bold" variant="h6">
                    Add Item
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography
                    variant="body2"
                    sx={{
                      color: !isProduct ? "primary.main" : "text.secondary",
                      fontWeight: !isProduct ? "bold" : "normal",
                    }}
                  >
                    Product
                  </Typography>
                </Grid>

                <Grid item>
                  <Switch
                    checked={isProduct}
                    onChange={handleToggle}
                    color="primary"
                    size="small"
                  />
                </Grid>

                <Grid item>
                  <Typography
                    variant="body2"
                    sx={{
                      color: isProduct ? "primary.main" : "text.secondary",
                      fontWeight: isProduct ? "bold" : "normal",
                    }}
                  >
                    Service
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Right side: Close Icon */}
            <Grid item>
              <IconButton onClick={handleClose}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={12} sm={4}>
              <WSTextField
                label={"Item Name *"}
                {...register("itemName")}
                id="itemName"
                name="itemName"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <WSAutocompleteField
                label={"Item HSN"}
                rules={{ required: true }}
                {...register("itemHsn")}
                id={"itemHsn"}
                name={"itemHsn"}
                control={control}
              />
            </Grid>
            <Grid item xs={12} sm={1}>
              <WSIcons.SearchRoundedIcon />
            </Grid>
            <Grid item xs={12} sm={1}>
              <Button variant="outlined" size="small">
                Edit Unit
              </Button>
              <Typography variant="caption">1 ML = 10 LTR</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <WSTextField
                label={"Item Code"}
                {...register("itemCode")}
                id="itemCode"
                name="itemCode"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <WSSelectField
                rules={{ required: true }}
                control={control}
                id="category"
                {...register("category")}
                name="category"
                label="Category"
              />
            </Grid>
            <Grid item xs={12}>
              <WSImageUpload
                control={control}
                id="addItemImage"
                name="addItemImage"
                label="Add Item Image"
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12}>
              <WSTabs
                id="partTab"
                setValue={setValue}
                control={control}
                name="partTab"
                tabs={tabsData}
                selectedTab={tabNum}
                justifyTabs="flex-start"
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
        <Grid item>
          <WSButton
            id="submit"
            type="submit"
            label="Save & New"
            size="medium"
            variant="outlined"
            color="primary"
            onClick={handleSubmit(handleDataSaveAndNew)}
            loading={loadingSaveAndNew}
            sx={{
              borderRadius: 2,
              border: "1px solid rgba(126, 176, 246, 1)",
              color: "rgba(126, 176, 246, 1)",
              backgroundColor: "#FFFFFF",
            }}
          />
        </Grid>

        <Grid item>
          <WSButton
            id="submit"
            type="submit"
            label="Save"
            size="medium"
            variant="outlined"
            color="primary"
            loading={loading}
            onClick={handleSubmit(handleData)}
            sx={{
              borderRadius: 2,
              width: "6rem",
              border: "1px solid rgba(126, 176, 246, 1)",
              color: "#FFFFFF",
              backgroundColor: "rgba(126, 176, 246, 1)",
              "&:hover": {
                backgroundColor: "rgba(126, 176, 246, 1)",
              },
            }}
          />
        </Grid>
      </Grid>
    </form>
  );
});
